<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Asistencia de personal</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <BaseInput v-model="search" label="Buscar" append-icon="mdi-magnify" style="max-width: 300px" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="filteredPersonal" class="transparent">
                  <template v-slot:[`item.nombreCompleto`]="{ item }">
                    {{ item.nombreCompleto }}
                  </template>
                  <template v-slot:[`item.CUIP`]="{ item }">
                    <span>{{ item.CUIP || 'Sin datos' }}</span>
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    {{ item.puesto }}
                  </template>
                  <template v-slot:[`item.dependencia`]="{ item }">
                    {{ item.dependencia }}
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-card-account-details-outline"
                              :elevation="8"
                              :to="{
                                name: 'enlace.expedientePersonalSection',
                                params: { id: item.id_personal },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver Expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-account-plus"
                              :elevation="8"
                              @click="openRegistroAsistenciaDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Registrar Asistencia</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              :elevation="8"
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-list-box-outline"
                              @click="openListadoAsistenciasDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Listado de asistencias</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              elevation="8"
                              variant="secondary"
                              icon="mdi-format-list-checks"
                              :to="{ name: 'enlace.fatigaEntregaRecepcion', query: { idPersonal: item.id_personal } }"
                            />
                          </span>
                        </template>
                        <span>Fatiga entrega/recepción</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseInput from '../base/BaseInput.vue'
import IconButton from '../base/IconButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: {
    IconButton,
    BaseInput,
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombreCompleto', width: '250px' },
        { text: 'CUIP', value: 'CUIP', width: '180px' },
        { text: 'Puesto', value: 'puesto', width: '150px' },
        { text: 'Dependencia', value: 'dependencia', width: '180px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '200px' },
      ],
      loading: false,
      search: '',
      DIALOG_TYPES,
      personalData: [],
      currentPage: 1,
      rowsPerPage: 100,
      idSede: null,
    }
  },
  computed: {
    ...mapGetters({
      idPersonal: 'getIdPersonal',
    }),

    filteredPersonal() {
      if (!this.search) return this.personalData

      const searchLower = this.search.toLowerCase()
      return this.personalData.filter((item) => {
        const nombreCompleto = (item.nombreCompleto || '').toLowerCase()
        const cuip = (item.CUIP || '').toLowerCase()
        const puesto = (item.puesto || '').toLowerCase()
        const dependencia = (item.dependencia || '').toLowerCase()
        const subsede = (item.Subsede || '').toLowerCase()

        return (
          nombreCompleto.includes(searchLower) ||
          cuip.includes(searchLower) ||
          puesto.includes(searchLower) ||
          dependencia.includes(searchLower) ||
          subsede.includes(searchLower)
        )
      })
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('personal', ['fetchSedePersonal']),

    openRegistroAsistenciaDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.REGISTRAR_ASISTENCIA,
        props: {
          selectedPersonal: {
            ...item,
            idPersonal: item.id_personal,
          },
        },
      })
    },

    openListadoAsistenciasDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.LISTADO_DE_ASISTENCIAS,
        props: {
          selectedPersonal: {
            ...item,
            idPersonal: item.id_personal,
          },
        },
      })
    },

    async loadPersonalBySede() {
      this.loading = true
      try {
        const idSede = this.idSede

        let response = null

        if (idSede) {
          response = await this.$store.dispatch('sede/fetchPersonalBySede', {
            pageNumber: this.currentPage,
            rowsOfPage: this.rowsPerPage,
            idSede: idSede,
          })
        } else {
          this.SET_SNACKBAR_MESSAGE('No se encontró información de sede/subsede. Por favor, contacte al administrador.')
          this.personalData = []
          return
        }

        if (response && response.data && Array.isArray(response.data)) {
          this.personalData = response.data
        } else {
          this.personalData = []
          this.SET_SNACKBAR_MESSAGE('No se encontró personal para esta sede/subsede.')
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar el personal. Por favor, intente nuevamente.')
        this.personalData = []
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    await this.$store.dispatch('sede/fetchSedes')
    const { idSede } = await this.fetchSedePersonal(this.idPersonal)
    this.idSede = idSede
    await this.loadPersonalBySede()
  },
}
</script>
